import { of } from "rxjs";

function defaultErrorHandler(error, defValue = null) {
  console.error(error);
  return of(defValue);
}

export default defaultErrorHandler;
